function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6 1.14l.26.26a.5.5 0 01.14.52l-6.04 16.75a.5.5 0 01-.47.33h-.16a.51.51 0 01-.46-.29l-3.39-7.19-7.19-3.39A.51.51 0 011 7.67v-.16A.5.5 0 011.33 7l16.75-6a.47.47 0 01.17 0 .5.5 0 01.35.14zM11 12.12l1.23 2.66 3.92-10.93L5.22 7.77 7.88 9a2 2 0 002.26-.29l1.69-1.56a.5.5 0 01.69 0l.38.38a.5.5 0 010 .69l-1.56 1.69a2 2 0 00-.34 2.21z"
});

var SvgSendOutlined = function SvgSendOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "#F8F9FA"
  }, props), _ref);
};

export default SvgSendOutlined;